import {
  IDuTruHocBongRequest,
  ITyLeHocBongSaveRequest,
} from "../../model/request/bao-cao/IDuTruHocBongRequest";
import { apiClient } from "../apiClient";

const ENDPOINT = "du-tru-hoc-bong";

export const duTruHocBongApi = {
  Select: (request: IDuTruHocBongRequest) =>
    apiClient.post(`${ENDPOINT}/select`, request),
  ExportExcel: (request: IDuTruHocBongRequest) =>
    apiClient.post(`${ENDPOINT}/export-excel`, request),
  /** Bản xem trước (HTML dựng từ chính tệp Excel sẽ xuất) — dùng cho màn Thiết lập in / in PDF. */
  XemTruoc: (request: IDuTruHocBongRequest) =>
    apiClient.post(`${ENDPOINT}/xem-truoc`, request),

  SelectTyLe: (hoc_ky: number, nam_hoc: string) =>
    apiClient.get(`${ENDPOINT}/ty-le?hoc_ky=${hoc_ky}&nam_hoc=${nam_hoc}`),
  SaveTyLe: (request: ITyLeHocBongSaveRequest) =>
    apiClient.post(`${ENDPOINT}/ty-le`, request),

  /**
   * Phạm vi + cột khóa của CẢ KỲ cho bảng khai tỷ lệ. Cố tình không theo bộ lọc màn hình: tỷ lệ
   * khai một lần rồi áp cho cả kỳ, lọc còn một hệ thì các hệ khác phải vẫn khai được.
   */
  SelectPhamVi: (request: IDuTruHocBongRequest) =>
    apiClient.post(`${ENDPOINT}/pham-vi`, request),

  /** Cả BẢNG khai tỷ lệ: mỗi ô là một cấp (khoa / ngành) × khóa học. */
  SelectTyLeBang: (hoc_ky: number, nam_hoc: string) =>
    apiClient.get(`${ENDPOINT}/ty-le-bang?hoc_ky=${hoc_ky}&nam_hoc=${nam_hoc}`),
  /** Ô nào người dùng xóa trắng thì KHÔNG gửi — máy chủ hiểu là bỏ khai riêng. */
  SaveTyLeBang: (request: ITyLeHocBongSaveNhieuRequest) =>
    apiClient.post(`${ENDPOINT}/ty-le-bang`, request),

  // "Học bổng thực tế" không có đường ghi riêng nữa: các ô vừa gõ gửi kèm trong LuuBan và
  // được chốt vào chính bản đó (user chốt 03/11).

  // ===== Thiết lập theo học kỳ =====
  SelectThietLap: (hoc_ky: number, nam_hoc: string) =>
    apiClient.get(`${ENDPOINT}/thiet-lap?hoc_ky=${hoc_ky}&nam_hoc=${nam_hoc}`),
  SaveThietLap: (request: IDuTruHocBongThietLap) =>
    apiClient.post(`${ENDPOINT}/thiet-lap`, request),

  // ===== Bản đã lưu =====
  /** Một bản kèm số liệu; KHÔNG truyền id = bản đã khóa của kỳ (chưa chốt thì rỗng). */
  SelectBan: (
    hoc_ky: number,
    nam_hoc: string,
    id?: number,
    /** Tỷ lệ % đang khai — bản giữ số học phí cũ nhưng học bổng tính theo tỷ lệ này. */
    ty_le?: number,
  ) =>
    apiClient.get(
      `${ENDPOINT}/ban?hoc_ky=${hoc_ky}&nam_hoc=${nam_hoc}&id=${id ?? 0}` +
        (ty_le === undefined || ty_le === null ? "" : `&ty_le=${ty_le}`),
    ),
  /** Phần trăm / niên chế / hệ số của một phiên bản (khai riêng nếu có, không thì theo kỳ). */
  SelectKhaiBan: (hoc_ky: number, nam_hoc: string, id: number) =>
    apiClient.get(
      `${ENDPOINT}/ban/khai?hoc_ky=${hoc_ky}&nam_hoc=${nam_hoc}&id=${id}`,
    ),
  /** Danh sách bản đã lưu của kỳ để chọn — không kèm số liệu nên gọi thoải mái. */
  SelectDanhSachBan: (hoc_ky: number, nam_hoc: string) =>
    apiClient.get(
      `${ENDPOINT}/ban/danh-sach?hoc_ky=${hoc_ky}&nam_hoc=${nam_hoc}`,
    ),
  /** Lưu THÊM một bản (không đè bản cũ) — máy chủ tự dựng lại biểu rồi lưu, trả id bản mới. */
  LuuBan: (
    request: IDuTruHocBongRequest & {
      ten_ban?: string;
      ghi_chu_ban?: string;
      /** Ô "Học bổng thực tế" đang gõ — chốt luôn vào bản này. */
      hoc_bong_thuc_tes?: IDuTruHocBongThucTeItem[];
      /** > 0 = ghi đè đúng bản đó ("Lưu bản hiện tại"); 0 / bỏ trống = thêm bản mới. */
      id_ban_sua?: number;
    },
  ) => apiClient.post(`${ENDPOINT}/ban/luu`, request),
  /** trang_thai: 2 = duyệt và khóa · 0 = mở khóa. id = 0 nghĩa là bản đang khóa của kỳ. */
  DoiTrangThai: (request: {
    hoc_ky: number;
    nam_hoc: string;
    id?: number;
    trang_thai: number;
    ghi_chu?: string;
  }) => apiClient.post(`${ENDPOINT}/ban/trang-thai`, request),
  /** Xóa một bản NHÁP; bản đã khóa thì máy chủ từ chối. */
  XoaBan: (id: number) => apiClient.post(`${ENDPOINT}/ban/xoa`, { id }),
  /** Đặt bản ĐANG DÙNG của kỳ — mở màn hình lên là thấy bản này. */
  DatActiveBan: (id: number) =>
    apiClient.post(`${ENDPOINT}/ban/dat-active`, { id }),
  SelectNhatKy: (hoc_ky: number, nam_hoc: string) =>
    apiClient.get(`${ENDPOINT}/nhat-ky?hoc_ky=${hoc_ky}&nam_hoc=${nam_hoc}`),
};

/** Một ô của bảng khai tỷ lệ; cấp không dùng thì để 0. */
export interface ITyLeHocBongItem {
  id_he: number;
  id_khoa: number;
  id_nganh: number;
  khoa_hoc: number;
  ty_le: number;
  /** Học phí niên chế một năm của phạm vi đó; 0 = chưa khai. */
  so_tien_nien_che: number;
  he_so_kha: number;
  he_so_gioi: number;
  he_so_xuat_sac: number;
}

export interface ITyLeHocBongSaveNhieuRequest {
  hoc_ky: number;
  nam_hoc: string;
  items: ITyLeHocBongItem[];
}

export interface IDuTruHocBongThucTeItem {
  /** Hệ của dòng; 0 khi biểu không tách theo hệ. */
  id_he: number;
  id_khoa: number;
  id_nganh: number;
  id_chuyen_nganh: number;
  /** Khóa học của CỘT trên biểu (cột gộp lấy chính mốc gộp). */
  khoa_hoc: number;
  so_tien: number;
}

/** Các ô học bổng thực tế gửi kèm khi Lưu bản. */
export interface IDuTruHocBongThucTeSaveRequest {
  hoc_ky: number;
  nam_hoc: string;
  items: IDuTruHocBongThucTeItem[];
}

/** Thiết lập của biểu, khai theo HỌC KỲ + NĂM HỌC. */
export interface IDuTruHocBongThietLap {
  hoc_ky: number;
  nam_hoc: string;
  he_so_kha: number;
  he_so_gioi: number;
  he_so_xuat_sac: number;
  so_thang_hk1: number;
  so_thang_hk2: number;
  /** JSON các lựa chọn còn lại (khoản thu, gom dòng, cột hiển thị...). */
  thiet_lap_json?: string;
}
